import React, {Component } from "react"
import Select from "react-select";
import { Form, Card } from 'react-bootstrap';

interface MatchRuleProps {
  mtchConfig: any;
  fields: any;
  triggerUpdate: boolean;
  handleUpdateMtchConfigChanges: (mtchConfig: any) => void;
}

interface MatchRuleState {
  mtchConfig: any;
}

class MatchRule extends Component<MatchRuleProps, MatchRuleState> {
  constructor(props: MatchRuleProps) {
    super(props);    
    this.state = {
	  mtchConfig: props.mtchConfig,
    };
  }
  
  componentDidUpdate(prevProps: MatchRuleProps) {
    if (this.props.mtchConfig !== prevProps.mtchConfig){
      this.setState({mtchConfig: this.props.mtchConfig});
    }
    if (this.props.triggerUpdate && prevProps.triggerUpdate != this.props.triggerUpdate){
      this.props.handleUpdateMtchConfigChanges(this.state.mtchConfig);
    }
  }
  
  setSelectedFldOptions = (fldNm: string, fldValList: string[])=>{
    let mtchConfig = this.state.mtchConfig;
    if (fldNm === 'matchFieldList'){
      mtchConfig.matchFieldList = fldValList;
    }else if (fldNm === 'matchFieldListExactOrAllNull'){
      mtchConfig.matchFieldListExactOrAllNull = fldValList;
    }else{
      mtchConfig.matchFieldListExactOrNull = fldValList;
    }
    this.setState({mtchConfig: mtchConfig});
  }
  
  
  handleSave = ()=>{
	
  }
  
  

  render() {
	const fldOptions = this.props.fields.map((m:any)=>{return { value: m.FLD_ID, label: m.COLUMN_DISPLAY_NAME }});
   
    
   const selectedExactFldOptions = this.state.mtchConfig.matchFieldList ? fldOptions.filter((item1: { value: string }) =>
      this.state.mtchConfig.matchFieldList.some((item2: string) => item1.value === item2)
    ):[];
    
    const selectedExactOrAllNullFldOptions = this.state.mtchConfig.matchFieldListExactOrAllNull ? fldOptions.filter((item1: { value: string }) =>
      this.state.mtchConfig.matchFieldListExactOrAllNull.some((item2: string) => item1.value === item2)
    ):[];
    
    const selectedExactOrNullFldOptions = this.state.mtchConfig.matchFieldListExactOrNull ? fldOptions.filter((item1: { value: string }) =>
      this.state.mtchConfig.matchFieldListExactOrNull.some((item2: string) => item1.value === item2)
    ):[];
	
    return (
		<div className="mt-2">
			
          <Card>
            <Card.Body>	
              <div>
                <Form.Group>
                  <Form.Label>Exact</Form.Label>
                  <Select
                      options={fldOptions}
                      isMulti
                      value={selectedExactFldOptions}
                      onChange={(selected) => {
                        console.log(selected);
                        const fldValList = selected.map(m => m.value);
                        this.setSelectedFldOptions('matchFieldList', fldValList);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                  />
              </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label>Exact or All Null (Null matches to Null)</Form.Label>
                  <Select
                      options={fldOptions}
                      isMulti
                      value={selectedExactOrAllNullFldOptions}
                      onChange={(selected) => {
                        console.log(selected);
                        const fldValList = selected.map(m => m.value);
                        this.setSelectedFldOptions('matchFieldListExactOrAllNull', fldValList);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                  />
                </Form.Group>
                <Form.Group  className="mt-3">  
                  <Form.Label>Exact or one Null (Null matches to Not Null)</Form.Label>
                  <Select
                      options={fldOptions}
                      isMulti
                      value={selectedExactOrNullFldOptions}
                      onChange={(selected) => {
                        console.log(selected);
                        const fldValList = selected.map(m => m.value);
                        this.setSelectedFldOptions('matchFieldListExactOrNull', fldValList);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                  />
                </Form.Group>
              </div>
            </Card.Body>
            

          </Card>
		</div>
    );
  }
}


export default MatchRule;